import { isLocalDev } from '@mfl/framework';

export const route = '/v1/account-settings';
export const WEBAPP_BASE_URL = isLocalDev ? 'http://localhost:9081' : '';
export const validateEmailRegEx =
  /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/;
